export default __webpack_public_path__ + "static/media/kitchen5-afterD-2048w.24a70862.avif";